const tabKeys = {
  brand: 'brand',
  productSeries: 'product-series',
  model: 'model',
  unitType: 'unitType',
}

const { brand, productSeries, model } = tabKeys

const tabList = [
  {
    label: 'txt_Brand',
    key: brand,
    header: 'ctlg_ViewBrand',
    addHeader: 'ctlg_addBrand',
  },
  {
    label: 'txt_ProductSeries',
    key: productSeries,
    header: 'ctlg_ViewProductSeries',
    addHeader: 'ctlg_addProductSeries',
  },
  {
    label: 'txt_Model',
    key: model,
    header: 'ctlg_ViewModel',
    addHeader: 'ctlg_addModel',
  },
]

const successMessage = {
  brand: {
    add: 'msg_BrandAddedSuccessfully',
    update: 'msg_BrandUpdatedSuccessfully',
  },
  'product-series': {
    add: 'msg_ProductSeriesAddedSuccessfully',
    update: 'msg_ProductSeriesUpdatedSuccessfully',
  },
  model: {
    add: 'msg_ModelAddedSuccessfully',
    update: 'msg_ModelUpdatedSuccessfully',
  },
}

const payloadType = {
  [brand]: 'BRAND',
  [productSeries]: 'PRODUCT_SERIES',
  [model]: 'MODEL',
}

const brandProductInitial = {
  name: '',
  shortDescription: '',
  longDescription: '',
}

const commonForm = {
  name: {
    label: 'user_Name',
    validateTrigger: 'onChange',
    inputType: 'input',
    md: 24,
    sm: 24,
    required: true,
  },
  shortDescription: {
    label: 'ctlg_ShortDescription',
    validateTrigger: 'onChange',
    inputType: 'input',
    md: 24,
    sm: 24,
    required: true,
  },
  longDescription: {
    label: 'ctlg_LongDescription',
    validateTrigger: 'onChange',
    inputType: 'textArea',
    md: 24,
    sm: 24,
    required: true,
  },
}

const addModelForm = {
  brandId: {
    label: 'txt_Brand',
    validateTrigger: 'onChange',
    inputType: 'select',
    parentSelector: true,
    md: 24,
    sm: 24,
    required: true,
    showBrand: true,
  },
  productSeriesId: {
    label: 'txt_ProductSeries',
    validateTrigger: 'onChange',
    inputType: 'select',
    parentSelector: true,
    md: 24,
    sm: 24,
    required: true,
    showProduct: true,
  },
  ...commonForm,
  flyerId: {
    label: 'ctlg_UploadFlyer',
    validateTrigger: 'onChange',
    inputType: 'image',
    md: 24,
    sm: 24,
    acceptFileTypes: '.pdf',
    uploadSingle: true,
    uploadApi: true,
    takePhotoFlag: true,
  },
  brochureId: {
    label: 'ctlg_UploadBrochure',
    validateTrigger: 'onChange',
    inputType: 'image',
    md: 24,
    sm: 24,
    acceptFileTypes: '.pdf',
    uploadSingle: true,
    takePhotoFlag: true,
  },
  videoId: {
    label: 'ctlg_UploadMarketingVideo',
    validateTrigger: 'onChange',
    inputType: 'image',
    md: 24,
    sm: 24,
    acceptFileTypes: '.mp4,.mov,.avi,.wmv,.avchd,.webm,.flv',
    uploadSingle: true,
    takePhotoFlag: true,
    maxSize: 10,
  },
  technicalDocumentId: {
    label: 'ctlg_UploadTechnicalSpecificationDocuments',
    validateTrigger: 'onChange',
    inputType: 'image',
    md: 24,
    sm: 24,
    acceptFileTypes: '.pdf',
    uploadSingle: true,
    takePhotoFlag: true,
  },
  productVideosId: {
    label: 'ctlg_UploadProductVideos',
    validateTrigger: 'onChange',
    inputType: 'image',
    md: 24,
    sm: 24,
    acceptFileTypes: '.mp4,.mov,.avi,.wmv,.avchd,.webm,.flv',
    uploadSingle: false,
    takePhotoFlag: true,
    max: 3,
    maxSize: 10,
  },
  productImagesId: {
    label: 'ctlg_UploadProductImages',
    validateTrigger: 'onChange',
    inputType: 'image',
    md: 24,
    sm: 24,
    acceptFileTypes: '.png,.jpg,.jpeg,.webp',
    uploadSingle: false,
    max: 5,
    maxSize: 2,
  },
}

const addBrandForm = { ...commonForm }
const addProductForm = {
  brandId: {
    label: 'txt_Brand',
    validateTrigger: 'onChange',
    inputType: 'select',
    parentSelector: true,
    md: 24,
    sm: 24,
    required: true,
    showBrand: true,
  },
  ...commonForm,
}

const initialCatalogueSelect = {
  brandId: null,
  productSeriesId: null,
  modelId: null,
  [tabKeys.brand]: null,
  [tabKeys.productSeries]: null,
  [tabKeys.model]: null,
  selected: null,
  customId: null,
  unitType: null,
}

export {
  addBrandForm,
  addModelForm,
  addProductForm,
  brandProductInitial,
  payloadType,
  successMessage,
  tabKeys,
  tabList,
  initialCatalogueSelect,
}
